module.exports = __webpack_public_path__ + "img/1800-3_YR_2022_Disinformation.41c30319.png";